function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { classNames } from '../../../../utilities/css.js';
import { layer } from '../../../shared.js';
import styles from './TooltipOverlay.scss.js';
import { useI18n } from '../../../../utilities/i18n/hooks.js';
import { PositionedOverlay } from '../../../PositionedOverlay/PositionedOverlay.js';

function TooltipOverlay(_ref) {
  var active = _ref.active,
      activator = _ref.activator,
      _ref$preferredPositio = _ref.preferredPosition,
      preferredPosition = _ref$preferredPositio === void 0 ? 'above' : _ref$preferredPositio,
      preventInteraction = _ref.preventInteraction,
      id = _ref.id,
      children = _ref.children,
      accessibilityLabel = _ref.accessibilityLabel,
      width = _ref.width,
      padding = _ref.padding,
      borderRadius = _ref.borderRadius,
      zIndexOverride = _ref.zIndexOverride,
      instant = _ref.instant;
  var i18n = useI18n();
  var markup = active ? /*#__PURE__*/React.createElement(PositionedOverlay, {
    active: active,
    activator: activator,
    preferredPosition: preferredPosition,
    preventInteraction: preventInteraction,
    render: renderTooltip,
    zIndexOverride: zIndexOverride
  }) : null;
  return markup;

  function renderTooltip(overlayDetails) {
    var measuring = overlayDetails.measuring,
        desiredHeight = overlayDetails.desiredHeight,
        positioning = overlayDetails.positioning,
        chevronOffset = overlayDetails.chevronOffset;
    var containerClassName = classNames(styles.TooltipOverlay, measuring && styles.measuring, !measuring && styles.measured, instant && styles.instant, positioning === 'above' && styles.positionedAbove);
    var contentClassName = classNames(styles.Content, width && styles[width]);
    var contentStyles = measuring ? undefined : {
      minHeight: desiredHeight
    };
    var style = {
      '--pc-tooltip-chevron-x-pos': "".concat(chevronOffset, "px"),
      '--pc-tooltip-border-radius': borderRadius ? "var(--p-border-radius-".concat(borderRadius, ")") : undefined,
      '--pc-tooltip-padding': padding && padding === 'default' ? 'var(--p-space-1) var(--p-space-2)' : "var(--p-space-".concat(padding, ")")
    };
    return /*#__PURE__*/React.createElement("div", Object.assign({
      style: style,
      className: containerClassName
    }, layer.props), /*#__PURE__*/React.createElement("div", {
      id: id,
      role: "tooltip",
      className: contentClassName,
      style: _objectSpread(_objectSpread({}, contentStyles), style),
      "aria-label": accessibilityLabel ? i18n.translate('Polaris.TooltipOverlay.accessibilityLabel', {
        label: accessibilityLabel
      }) : undefined
    }, children));
  }
}

export { TooltipOverlay };